import { RSAA } from 'redux-api-middleware';
import { REQUEST, SUCCESS, FAILURE } from '@/modules/Requests';

const host = process.env.BACKEND_URL;

export const types = {
  SET_DATA: 'ARIFMETIKBOOK/SET_DATA',
  SET_NUMBER: 'SET_NUMBER',
  SET_ROOM: 'SET_ROOM',
  SET_CHANGE: 'SET_CHANGE',
  SET_UPDATE: 'SET_UPDATE',
  SET_PARAMS: 'SET_PARAMS',
  SET_CONTROLS: 'SET_CONTROLS',
  SET_DICTATION_STATE: 'SET_DICTATION_STATE',
  REQUEST_GET_ARGS: 'ARIFMETIKBOOK/REQUEST_GET_ARGS',
  REQUEST_GET_ARGS_TO_PRINT: 'ARIFMETIKBOOK/REQUEST_GET_ARGS_TO_PRINT',
  REQUEST_SEND_ANSWER: 'REQUEST_SEND_ANSWER',
};

export const MIN_RATE = 1.5;
export const RATE_SCALE = 2 / 3;
export const SOUND_URL = `${host}/arifmetik_book/sound/ru`;

// Init state
const initialState = {
  books: {},
  data: [[], [], [], [], [], []],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_DATA:
    case types.REQUEST_GET_ARGS:
      return {
        ...state,
        [action.meta]: action.payload,
      };
    default:
      return state;
  }
};

// Actions
const fetchArgs = (terminalCount = '1', formData) => ({
  [RSAA]: {
    endpoint: `${host}/arifmetik_book/args?terminal_count=${terminalCount}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_GET_ARGS,
      },
    })),
  },
});

const fetchArgsOnce = (number, terminalCount = '1', formData) => ({
  [RSAA]: {
    endpoint: `${host}/arifmetik_book/args?terminal_count=${terminalCount}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [
      { type: REQUEST },
      {
        type: SUCCESS,
        payload: (action, state, res) => res.json(),
      },
      { type: FAILURE },
    ].map(type => ({
      ...type,
      meta: {
        request: `${types.REQUEST_GET_ARGS}_${number}`,
      },
    })),
  },
});

export const fetchSendAnswer = data => ({
  [RSAA]: {
    endpoint: `${host}/arifmetik_book/answer`,
    method: 'POST',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_SEND_ANSWER,
      },
    })),
  },
});

// ].map(type => ({
//   ...type,
//   meta: {
//     request: types.REQUEST_LOGIN,
//     params: formData,
//   },
// })),

// headers: { 'Content-Type': 'application/json' },
// types: [
//   { type: REQUEST },
// {
//   type: SUCCESS,
//   payload: (action, state, res) => {
//     const token = res.headers.get('Authorization');
//     const expires = new Date();
//     expires.setDate(expires.getDate() + 364);
//     cookie.save('Authorization', token, {
//       path: '/',
//       expires,
//     });
//     return res.json();
//   },
// },
//   { type: FAILURE },
// ].map(type => ({
//   ...type,
//   meta: {
//     request: types.REQUEST_LOGIN,
//     params: formData,
//   },
// })),

const fetchArgsToPrint = formData => ({
  [RSAA]: {
    endpoint: `${host}/arifmetik_book/args_to_print`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_GET_ARGS_TO_PRINT,
      },
    })),
  },
});

export const actions = {
  fetchArgs,
  fetchArgsOnce,
  fetchArgsToPrint,
};

export default reducer;
